import * as React from 'react'

import { BlockedPeriodPolicyFragment } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import PanesPadForm from 'modules/core/components/PanesPadForm'

import type { DescriptionProps } from './Description'
import Description from './Description'
import Policies from './PolicyList/List'

interface BlockProps {
  data: BlockedPeriodPolicyFragment[]
  totalCount: number | null | undefined
  defaultLeaveTypeId: number
  canManageTimeOff: boolean
}

const BlockedPeriodsSettingsBlock: React.FC<BlockProps & DescriptionProps> = ({
  data,
  totalCount,
  title,
  description,
  multigroup = true,
  helpCenterUrlName,
  onAddPolicy,
  defaultLeaveTypeId,
  canManageTimeOff,
}) => {
  return (
    <PanesPadForm direction="horizontal" compact>
      <Description
        title={title}
        description={description}
        multigroup={multigroup}
        helpCenterUrlName={helpCenterUrlName}
        onAddPolicy={onAddPolicy}
        defaultLeaveTypeId={defaultLeaveTypeId}
        canManageTimeOff={canManageTimeOff}
      />
      <Policies data={data} totalCount={totalCount} />
    </PanesPadForm>
  )
}

export default observer(BlockedPeriodsSettingsBlock)
